import { render, staticRenderFns } from "./DocuformListItemDesktop.vue?vue&type=template&id=734d57e5&scoped=true"
import script from "./DocuformListItemDesktop.vue?vue&type=script&lang=js"
export * from "./DocuformListItemDesktop.vue?vue&type=script&lang=js"
import style0 from "./DocuformListItemDesktop.vue?vue&type=style&index=0&id=734d57e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734d57e5",
  null
  
)

export default component.exports